<template>
  <div class="row" style="height: 95%; overflow: hidden">
    <div class="col-md-12 py-1 px-3" style="height: 100%; overflow: hidden">
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control flex-grow-1"
          v-model="search"
          placeholder="Buscar"
        />

        <select
          v-model="status"
          name="status"
          class="form-control ml-2"
          style="width: 130px"
        >
          <option value="ativo">Ativo</option>
          <option value="inativo">Inativo</option>
        </select>
      </div>

      <load v-if="load" mode="table" class="mt-3" />

      <div
        v-else
        style="height: 70vh; overflow: auto"
        class="mt-2"
      >
        <!-- Contact Selected -->
        <ContactList
          v-if="
            selected &&
            selected.id &&
            selected.unidade_id == unidadeid &&
            (
              (status == 'ativo' && isContactActive(selected)) ||
              (status == 'inativo' && !isContactActive(selected))
            )
          "
          :contact="selected"
          :users="userOnline"
          :online="isContactOnline(selected)"
          @selected="selectContact(selected)"
          :selected="true"
        />

        <!-- Active contacts -->
        <ul
          v-if="search == '' && status == 'ativo'"
          class="list-group list-group-flush"
          style="
            list-style: none;
            max-height: 90%;
            overflow: auto;
          "
        >
          <ContactList
            v-for="contact in contactsActive"
            :key="contact.id"
            @selected="selectContact(contact)"
            :contact="contact"
            :online="isContactOnline(contact)"
          />
        </ul>

        <!-- Inactive contacts -->
        <ul
          v-if="search == '' && status == 'inativo'"
          class="list-group list-group-flush"
        >
          <ContactList
            v-for="contactoff in contactsInactive"
            :key="contactoff.id"
            @selected="selectContact(contactoff)"
            :contact="contactoff"
            :online="isContactOnline(contactoff)"
          />
        </ul>

        <!-- Contact Search -->
        <ul
          v-if="search != ''"
          class="list-group list-group-flush"
        >
          <ContactList
            v-for="contact in filterContacts"
            :key="contact.id"
            @selected="selectContact(contact)"
            :contact="contact"
            :online="isContactOnline(contact)"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ContactList from "./includes/ContactList";

export default {
  components: {
    ContactList,
  },

  props: {
    contacts: {
      type: Array,
      default: [],
    },
    load: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      selected: [],
      search: "",
      status: "ativo",
      loadContact: true,
      unidadeid: "",
    };
  },

  methods: {
    isContactActive(contact) {
      if (!contact) {
        return false;
      }

      // O fallback pelo ID atende contatos salvos no localStorage antes
      // de o backend passar a retornar chat_status.
      return contact.chat_status
        ? contact.chat_status == "ativo"
        : Number(contact.status) !== 131;
    },

    isContactOnline(contact) {
      if (!contact || !contact.id) {
        return false;
      }

      return this.$store.state.users.some((user) => {
        return (
          (contact.id == user.id ||
            contact.id == user.userID) &&
          user.unidadeID == this.unidadeid
        );
      });
    },

    checkUserOnline(user) {
      var online = this.$store.state.users.filter((u) => {
        if (
          (user.id == u.id || user.id == u.userID) &&
          u.unidadeID == this.unidadeid
        ) {
          return u;
        }
      });

      return online[0] > 0 ? true : false;
    },

    selectContact(contact) {
      this.selected = contact;
      this.search = "";

      localStorage.setItem(
        "user-chat-selected",
        JSON.stringify(contact)
      );

      this.$emit("selected", contact);
    },
  },

  mounted() {
    this.unidadeid = localStorage.getItem(
      "unidade-chat-selected"
    );

    var user_save = localStorage.getItem(
      "user-chat-selected"
    );

    if (user_save) {
      this.selected = JSON.parse(user_save);
    }

    if (
      this.selected &&
      this.unidadeid != this.selected.unidade_id
    ) {
      localStorage.removeItem("user-chat-selected");
      this.selecte = [];
    }
  },

  computed: {
    contactsActive() {
      return this.sortedContacts.filter((contact) => {
        if (
          this.isContactActive(contact) &&
          this.selected &&
          contact.id != this.selected.id
        ) {
          return contact;
        }
      });
    },

    contactsInactive() {
      return this.sortedContacts.filter((contact) => {
        if (
          !this.isContactActive(contact) &&
          this.selected &&
          contact.id != this.selected.id
        ) {
          return contact;
        }
      });
    },

    sortedContacts() {
      let sort = this.contacts.sort();

      return _.sortBy(this.contacts, "name", [
        (contact) => {
          if (contact.unread) {
            return Infinity;
          }
        },
      ]);

      // return _.sortBy(this.contacts, [
      //   (contact) => {
      //     if (contact) {
      //       if (
      //         this.selected &&
      //         contact.id == this.selected.id
      //       ) {
      //         return Infinity;
      //       }
      //
      //       return contact.unread;
      //     }
      //   },
      // ]).reverse();
    },

    filterContacts: function () {
      return this.sortedContacts.filter((contact) => {
        var matchesSearch = contact.name
          .toLowerCase()
          .includes(this.search.toLowerCase());

        var matchesStatus =
          this.status == "ativo"
            ? this.isContactActive(contact)
            : !this.isContactActive(contact);

        var isNotSelected =
          !this.selected ||
          contact.id != this.selected.id;

        return (
          matchesSearch &&
          matchesStatus &&
          isNotSelected
        );
      });
    },

    userOnline() {
      return this.$store.state.users;
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
  background-color: #f4f4f4;
}

::-webkit-scrollbar {
  width: 5px;
  background: #f4f4f4;
}

::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 25em;
}

.unread {
  background: #fb8994;
  color: #fff;
  right: 11px;
  min-width: 20px;
  /* top: 20px; */
  align-items: center;
  line-height: 20px;
  font-size: 12px;
  padding: 0 4px;
  /* float: right; */
  z-index: 1010;
  /* position: absolute; */
  text-align: center;
  border-radius: 10px;
}

.contacts-list {
  flex: 2;
  height: 58vh;
  overflow: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact:hover {
  color: #0d5a9e;
}

.availability-status {
  font-size: 8px;
}

.availability-status.online {
  color: #1bcfb4;
}

.availability-status .offline {
  background: #ccc;
}

.user-list {
  /* min-height: 50px; */
  border-bottom: 1px solid #eaeaea;
}

.user-list:hover {
  cursor: pointer;
  background: #f4f4f4;
}
</style>
